/**
 * Shared constants for mock data generation and handlers.
 *
 * Centralized values to avoid duplication across mock files.
 */

// Mock API Configuration
export const MOCK_API_DELAY_MS = 500;
export const MOCK_EVENT_INTERVAL_MS = 2000;
export const MOCK_SESSION_TIMEOUT_MS = 10 * 60 * 1000; // 10 minutes

// Mock Payment Data
export const MOCK_PAYMENT_BASE_URL = 'https://btpay.com/payment/';
export const MOCK_DEFAULT_AMOUNT = 10000;
export const MOCK_DEFAULT_CURRENCY = 'GBP';
export const MOCK_DEFAULT_CUSTOMER_ID = 'mock-customer-123';

// Event Status Messages
export const EVENT_STATUS = {
  LINK_CREATED: 'Link created',
  LINK_OPENED: 'Link opened',
  PAYMENT_METHOD_SELECTED: 'Payment method selected',
  CARDHOLDER_NAME_ENTERED: 'Name on card entered',
  CARD_NUMBER_ENTERED: 'Card number entered',
  EXPIRY_ENTERED: 'Expiration date entered',
  CVC_ENTERED: 'CVC entered',
  PAYMENT_COMPLETE: 'Payment complete',
  PAYMENT_FAILED: 'Payment failed',
  PAYMENT_CANCELLED: 'Payment cancelled',
  SESSION_EXPIRED: 'Session expired',
} as const;

// Payment Status Values (Backend Orchestrator enum values)
export const PAYMENT_STATUS = {
  INITIATED: 'INITIATED',
  AUTHORISED: 'AUTHORISED',
  CAPTURED: 'CAPTURED',
  SETTLED: 'SETTLED',
  DECLINED: 'DECLINED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
  EXPIRED: 'EXPIRED',
} as const;
